import { render, staticRenderFns } from "./myFigure.vue?vue&type=template&id=dcd2b6b4&scoped=true"
import script from "./myFigure.vue?vue&type=script&lang=js"
export * from "./myFigure.vue?vue&type=script&lang=js"
import style0 from "./myFigure.vue?vue&type=style&index=0&id=dcd2b6b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd2b6b4",
  null
  
)

export default component.exports